import service from "services/maintenance/taxBracketService";
import TaxScheduleForm from "features/maintenance/components/DedicatedForms/TaxScheduleForm";
import { EventNoteOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

const isEditing = (formData) => {
    return !!formData?.id;
};

const taxBracketResource = {
    title: "Tax Bracket",
    singular: "Tax Bracket",
    displayField: "minAmount",
    editableForm: TaxScheduleForm,
    pageIcon: EventNoteOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.TAX_SCHEDULE,
    service: service,

    columns: [
        {
            field: "minAmount",
            header: "Over",
            type: "decimal"
        },
        {
            field: "maxAmount",
            header: "But Not Over",
            type: "decimal"
        },
        {
            field: "taxRatePercent",
            header: "In Excess",
            type: "decimal"
        }
    ],

    fields: [
        {
            name: "minAmount",
            field: "minAmount",
            label: "Over",
            type: "number",
            required: true,
            unique: true
            // disabledResolver: isEditing
        },
        {
            name: "maxAmount",
            field: "maxAmount",
            label: "But Not Over",
            type: "number",
            required: true
            // disabledResolver: isEditing
        },
        {
            name: "taxRatePercent",
            field: "taxRatePercent",
            label: "In Excess",
            type: "number",
            required: true,
            unique: true
            // disabledResolver: isEditing
        }
    ],
    searchFields: ["minAmount"]
};

export default taxBracketResource;
